var exports = {
  "r": "version__WSUm2M",
};

module.exports = exports;
